import { useEffect, useState } from 'react';

export enum FundingStatus {
  Sent = 'Sent',
  Passed = 'Passed',
  Failed = 'Failed',
}

const FUNDING_STATUS_LOCAL_STORAGE_KEY = 'funding_status';
const getFundingStatusLocalStorageKey = (applicationId: string) =>
  `${applicationId}_${FUNDING_STATUS_LOCAL_STORAGE_KEY}`;

const setFundingStatusToLocalStorage = (status: FundingStatus, applicationId: string): void => {
  const localStorageKey = getFundingStatusLocalStorageKey(applicationId);

  localStorage.setItem(localStorageKey, status);
};

export const compareLocalStorageFundingStatus = (status: FundingStatus, applicationId: string): boolean => {
  const localStorageKey = getFundingStatusLocalStorageKey(applicationId);

  const fundingStatusFromLocalStorage = localStorage.getItem(localStorageKey);

  return fundingStatusFromLocalStorage === status;
};

export const getFundingStatusFromLocalStorage = (applicationId: string): FundingStatus | null => {
  const localStorageKey = getFundingStatusLocalStorageKey(applicationId);

  return (localStorage.getItem(localStorageKey) as FundingStatus) || null;
};

export const useFundingStatus = (applicationId: string) => {
  const [fundingStatus, setFundingStatus] = useState<FundingStatus | null>(
    getFundingStatusFromLocalStorage(applicationId),
  );

  useEffect(() => {
    if (fundingStatus) {
      setFundingStatusToLocalStorage(fundingStatus, applicationId);
    }
  }, [fundingStatus]);

  const compareFundingStatus = (status: FundingStatus): boolean => {
    return fundingStatus === status;
  };

  return {
    fundingStatus,
    setFundingStatus,
    compareFundingStatus,
  };
};
